import { SpecializationApi } from 'woofwoof-api';
import client, { axiosBaseUrl } from './client';

export const specializationApi = new SpecializationApi(
  {
    basePath: axiosBaseUrl,
    isJsonMime: () => false,
  },
  undefined,
  //@ts-ignore
  client,
);
